import { render, staticRenderFns } from "./PdfElement.vue?vue&type=template&id=c494c1e8&scoped=true&"
import script from "./PdfElement.vue?vue&type=script&lang=ts&"
export * from "./PdfElement.vue?vue&type=script&lang=ts&"
import style0 from "./PdfElement.vue?vue&type=style&index=0&id=c494c1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c494c1e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTooltip})
